import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt')?.toString().trim() || '';
    if (honeypot) {
      setStatus('success');
      setMessage('订阅成功！感谢你的关注。');
      setEmail('');
      return;
    }

    setStatus('loading');
    try {
      const res = await fetch('https://readdy.ai/api/form/d9obrjobdkpk99j7gtq0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email }).toString(),
      });
      const responseText = await res.text();
      if (res.ok) {
        setStatus('success');
        setMessage('订阅成功！感谢你的关注，精彩影视资讯将送达你的邮箱。');
        setEmail('');
      } else {
        setStatus('error');
        setMessage('订阅失败，请稍后重试。');
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查网络连接后重试。');
    }
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20cinematic%20background%20with%20soft%20golden%20light%20streaks%2C%20deep%20navy%20and%20charcoal%20tones%2C%20elegant%20movie%20themed%20texture%2C%20subtle%20film%20grain%2C%20atmospheric%20night%20mood%2C%20luxurious%20dark%20aesthetic&width=1600&height=600&seq=newsletter-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-background-950/80"></div>
      </div>

      <div className="relative max-w-xl mx-auto text-center">
        <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-500/15 mx-auto mb-5">
          <i className="ri-mail-send-line text-2xl text-primary-500"></i>
        </div>
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-50 mb-3">
          加入夜猫子观影团
        </h2>
        <p className="text-foreground-600 text-sm md:text-base mb-8">
          订阅我们的影视资讯，第一时间获取热门大片上线通知和独家观影指南
        </p>

        <form
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row items-center gap-3"
          data-readdy-form=""
        >
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="请输入你的邮箱地址"
            required
            className="flex-1 w-full sm:w-auto px-5 py-3 text-sm rounded-lg bg-background-800/80 border border-background-600/40 text-foreground-200 placeholder:text-foreground-700 focus:outline-none focus:border-primary-500/50 transition-colors"
          />
          <input
            type="text"
            name="phone_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="website-alt-field"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="w-full sm:w-auto px-8 py-3 text-sm font-medium rounded-lg bg-primary-500 text-background-950 hover:bg-primary-600 transition-all whitespace-nowrap disabled:opacity-60 cursor-pointer"
          >
            {status === 'loading' ? (
              <span className="flex items-center gap-2">
                <i className="ri-loader-4-line animate-spin"></i>
                提交中...
              </span>
            ) : (
              '立即订阅'
            )}
          </button>
        </form>

        {status === 'success' && (
          <p className="mt-4 text-sm text-primary-500 font-medium">{message}</p>
        )}
        {status === 'error' && (
          <p className="mt-4 text-sm text-accent-500 font-medium">{message}</p>
        )}

        <p className="mt-4 text-foreground-700 text-xs">
          我们尊重你的隐私，不会分享你的邮箱给第三方
        </p>
      </div>
    </section>
  );
}